import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { PdfControls } from "./components";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
/**
 *
 * @param {object} props
 * @param {string} props.src
 * @param {any} props.className
 * @param {any} props.style
 */

export const PdfViewer = ({
  src,
  className,
  style
}) => {
  const pdfClassName = classNames(["shadow rounded w-full overflow-auto pdf-scroll"], className);
  const STEP_ZOOM = 0.2;
  const [total, setTotal] = useState(1);
  const [page, setPage] = useState(1);
  const [scale, setScale] = useState(1);

  const onLoad = pdf => {
    setTotal(pdf?.numPages);
    console.log(pdf);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(PdfControls, {
    page: page,
    total: total,
    onNext: () => setPage(page + 1),
    onPrevious: () => setPage(page - 1),
    scale: scale,
    onZoomIn: () => setScale(scale + STEP_ZOOM),
    onZoomOut: () => setScale(scale - STEP_ZOOM),
    onDownload: console.log,
    className: "absolute bottom-0 left-0 right-0 mb-8 mx-4 pr-4 z-10",
    src: src
  }), /*#__PURE__*/React.createElement("div", {
    className: pdfClassName,
    style: style
  }, /*#__PURE__*/React.createElement(Document, {
    file: src,
    onLoadSuccess: onLoad,
    onLoadError: console.error
  }, /*#__PURE__*/React.createElement(Page, {
    pageNumber: page,
    scale: scale
  }))));
};
PdfViewer.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.any,
  style: PropTypes.any
};